import React, { Component } from 'react';
import Table from '../../components/generic/table/Table';
import {
  PageContainer,
  PageTitle,
  HeaderContainer,
  HeaderTitle,
  HeaderButtonsContainer,
  SectionTitle
} from '../../styles/BasicStyles';
import {
  GetMaterialEvents,
  GetMaterial
} from '../../infra/requests/MaterialsRequests';
import BaseButton from '../../components/generic/buttons/BaseButton';
import MaterialsEventsFilters from './MaterialsEventsFilters';
import { getQuerySortName } from '../../infra/services/utils/QuerySortTypes';
import * as moment from 'moment';

class MaterialsEventPage extends Component {
  state = {
    loading: false,
    material: {},
    filters: '',
    columns: [
      {
        title: 'Nome',
        sorter: true,
        dataIndex: 'name'
      },
      {
        title: 'Inicio do evento',
        sorter: true,
        dataIndex: 'startDate',
        render: (date) => moment(date).format('DD-MM-YYYY')
      },
      {
        title: 'Fim do evento',
        sorter: true,
        dataIndex: 'endDate',
        render: (date) => moment(date).format('DD-MM-YYYY')
      },
      {
        title: 'Inicio da montagem',
        sorter: true,
        dataIndex: 'assemblyStartDate',
        render: (date) => moment(date).format('DD-MM-YYYY')
      },

      {
        title: 'Fim da desmontagem',
        sorter: true,
        dataIndex: 'disassemblyEndDate',
        render: (date) => moment(date).format('DD-MM-YYYY')
      },
      {
        title: 'Local',
        sorter: true,
        dataIndex: 'addressLocal'
      }
    ],
    sorter: '',
    pageSize: 30,
    currentPage: 1,
    rows: [],
    total: 0
  };

  componentDidMount = async () => {
    await this.updateMaterial();
    await this.updateMaterialsEvents();
  };

  updateMaterial = async () => {
    const {
      match: { params }
    } = this.props;

    if (params.id) {
      const result = await GetMaterial(params.id);
      this.setState({ material: result.data });
    }
  };

  handleOnPressRow = (record) => {
    const { history } = this.props;
    history.push(`/events/${record._id}`);
  };

  handleChangePage = (currentPage) => {
    this.setState({ currentPage }, this.updateMaterialsEvents);
  };

  handleChangeRowsPerPage = (currentSize, pageSize) => {
    this.setState({ pageSize, currentPage: 1 }, this.updateMaterialsEvents);
  };

  updateMaterialsEvents = async () => {
    this.setState({ loading: true });
    try {
      const {
        match: { params }
      } = this.props;
      const { currentPage, pageSize, filters, sorter } = this.state;
      const result = await GetMaterialEvents(
        params.id,
        currentPage,
        pageSize,
        filters,
        sorter
      );
      this.setState({
        rows: result.data.items,
        total: result.data.total,
        loading: false
      });
    } catch (e) {
      this.setState({ loading: false });
      console.error(e);
    }
  };

  handleTableChange = (pagination, filters, sorter) => {
    const sortObject = JSON.stringify({
      [sorter.field]: getQuerySortName(sorter.order)
    });
    this.setState({ sorter: sortObject }, this.updateMaterialsEvents);
  };

  handleFilterChange = (filters) => {
    this.setState({ filters }, this.updateMaterialsEvents);
  };

  handleOnCancel = async () => {
    const { history } = this.props;
    return history.push('/materials');
  };

  render() {
    const {
      loading,
      columns,
      currentPage,
      total,
      pageSize,
      rows,
      material
    } = this.state;
    return (
      <React.Fragment>
        <HeaderContainer>
          <HeaderTitle buttons={2}>
            <PageTitle>Lista de Eventos</PageTitle>
            {`Materiais > ${material.name} > Eventos`}
          </HeaderTitle>
          <HeaderButtonsContainer buttons={2}>
            <BaseButton
              type={'default'}
              icon={'sync'}
              text={'Atualizar'}
              onClick={this.updateMaterialsEvents}
            />
            <BaseButton
              type="default"
              icon="close"
              text="Cancelar"
              onClick={this.handleOnCancel}
            />
          </HeaderButtonsContainer>
        </HeaderContainer>
        <PageContainer>
          <MaterialsEventsFilters queryChange={this.handleFilterChange} />
          <SectionTitle style={{ marginTop: 15 }}>Eventos</SectionTitle>
          <Table
            columns={columns}
            currentPage={currentPage}
            pageSize={pageSize}
            loading={loading}
            rows={rows}
            showHeader={true}
            emptyIcon="solution"
            emptyText={'Não existe nenhum evento a utilizar o material'}
            total={total}
            rowKey={'_id'}
            hasPagination={true}
            onPressRow={this.handleOnPressRow}
            onSortChange={this.handleTableChange}
            handleChangePage={this.handleChangePage}
            handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </PageContainer>
      </React.Fragment>
    );
  }
}

export default MaterialsEventPage;
